import { render, staticRenderFns } from "./DemoRoom.vue?vue&type=template&id=3c07bf4c&scoped=true&"
import script from "./DemoRoom.vue?vue&type=script&lang=ts&"
export * from "./DemoRoom.vue?vue&type=script&lang=ts&"
import style0 from "./DemoRoom.vue?vue&type=style&index=0&id=3c07bf4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c07bf4c",
  null
  
)

export default component.exports